<template>
	<div
		class="wrap"
		style="background: url('http://futureprize.org/resource/images/banner-bg.jpg'); height: 100vh;"
	>
		<swiper
			style="padding-top: 20vh;"
			ref="mySwiper"
			:options="swiperOption"
			@slideChangeTransitionStart="myhandler(swiper)"
		>
			<swiper-slide
				class="swiper-slide"
				v-for="(item, index) in dataList"
				:key="index"
			>
				<div class="swiper-menu">
					<div class="title">{{ item.title }}</div>
					<div class="time">{{ item.times.split(' ')[0] }}</div>
					<router-link
						:to="'/activity/list?type=' + item.typeIds[ind]"
						style="display: block; color: #fff; font-size: 1rem; text-decoration: underline"
						class="mt-3 mb-2"
						v-for="(titleitem, ind) in item.typeIdsName"
						:key="ind"
					>
						{{ titleitem }}
					</router-link>
				</div>
				<img
					style="width: 60%;margin-left: 16rem;height: 32rem; min-width: 32rem;"
					:src="item.titlePhoto"
				/>
			</swiper-slide>
			<div class="swiper-button-prev" slot="button-prev"></div>
			<div class="swiper-button-next" slot="button-next"></div>
		</swiper>
		<b-container>
			<div class="time-line">
				<div class="title"><a>往期回顾</a></div>
				<div
					:class="['item', current == index ? 'active' : '']"
					v-for="(item, index) in yearList"
					:key="index"
					@click="clickItem(index)"
				>
					<span>{{ item }}</span
					><i></i>
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
export default {
	computed: {
		// 获取swiper实例
		swiper() {
			return this.$refs.mySwiper.$swiper
		},
	},
	data() {
		return {
			dataList: [],
			yearList: [],
			current: 0,
			swiperOption: {
				effect: 'coverflow',
				grabCursor: true,
				centeredSlides: true,
				loop: true,
				slidesPerView: 2,
				mousewheel: true,
				autoplay: {
					delay: 3000, //自动播放速度
					disableOnInteraction: false, //鼠标移上去时是否还继续播放
				},
				coverflowEffect: {
					rotate: 0,
					stretch: 2,
					depth: 50,
					modifier: 6,
					slideShadows: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			},
		}
	},
	created() {
		this.getBannerList()
	},
	methods: {
		getBannerList() {
			this.$api.getPrizeLookBack().then((res) => {
				this.dataList = res.data
				this.yearList = res.data.map((item) => {
					return item.year
				})
			})
		},
		myhandler(swiper) {
			this.current = swiper.realIndex
		},
		clickItem(index) {
			this.swiper.slideToLoop(index, 1000, false)
			this.current = index
		},
	},
}
</script>
<style lang="scss" scoped>
.swiper-slide.swiper-slide-active img {
	transform: scaleX(1.6);
	border-radius: 5px;
}
.swiper-slide-prev::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgb(66 66 66 / 60%);
	z-index: 99;
}
.swiper-slide.swiper-slide-next::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgb(66 66 66 / 60%);
	z-index: 99;
}
.swiper-button-next,
.swiper-button-prev {
	margin-top: 1rem;
	width: 5rem;
	height: 5rem;
	color: #ffffff;
	background-color: #000;
	opacity: 0.5;
	border-radius: 50%;
}

.swiper-button-prev {
	margin-left: 6rem;
}

.swiper-button-next {
	margin-right: 6rem;
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
	background-color: #333;
	opacity: 0.8;
}

.swiper-button-prev::after,
.swiper-button-next::after {
	font-size: 1.5rem;
}

.swiper-menu {
	position: absolute;
	top: 1rem;
	width: 14rem;
	height: 30rem;
	background: #753eff;
	color: #ffffff;
	font-size: 0.8rem;
	padding: 2rem 1rem;
	z-index: 999;
	.title {
		margin: 2rem 0px;
		font-size: 1rem;
		font-weight: bold;
	}
}
.time-line {
	display: flex;
	color: #fff;
	height: 6rem;
	line-height: 6rem;
	border-bottom: 0.1rem solid #fff;
	.title {
		padding-right: 1.2rem;
		a {
			padding: 0 2rem;
			border-right: 0.1rem solid #fff;
		}
	}
	.item {
		padding: 0px 2rem;
		font-size: 1.2rem;
		color: #a0a0a0;
		i {
			display: none;
		}
	}
	.active {
		font-size: 1.6rem;
		padding: 0px 1rem;
		color: #ffffff;
		i {
			display: block;
			width: 0.5rem;
			height: 0.5rem;
			margin: 0 auto;
			margin-top: -1.5rem;
			background: #753eff;
		}
	}
}
</style>
